import { useSearch as useLegacySearch } from '@legacy/apis/searchAPI';

import { useSearchStore } from '@/stores/search';
import { SearchResultsProps } from '../types';
import { SearchResultsList } from './SearchResultsList';
import { SearchResultsEmptyState } from './SearchResultsEmptyState';

export const LegacySearchResults = ({
  searchValue,
  onItemSelect,
  searchContainerResults,
}: SearchResultsProps) => {
  const { getCategoryListString } = useSearchStore();
  const { searchResult, isSearchResultEmpty } = useLegacySearch(
    searchValue,
    getCategoryListString(),
  );

  if (!isSearchResultEmpty) {
    return (
      <SearchResultsList
        searchResult={searchResult}
        searchValue={searchValue}
        onItemSelect={onItemSelect}
        searchContainerResults={searchContainerResults}
      />
    );
  }

  if (isSearchResultEmpty) {
    return <SearchResultsEmptyState />;
  }

  return null;
};
